import Cookies from "js-cookie";
import React from "react";
import Toggle from "react-toggle";
import { useDialog } from "src/contexts/dialog-context";

const CacheSettings: React.FC = () => {
  const dialog = useDialog();

  const calculateLocalStorageSize = () => {
    let total = 0;
    for (const key in localStorage) {
      if (localStorage.getItem(key)) {
        total += (localStorage[key].length + key.length) * 2; // Cada caractere ocupa 2 bytes
      }
    }
    return (total / 1024).toFixed(2); // Retorna em KB
  };

  const calculateCookiesSize = () => {
    const cookies = Cookies.get();
    let total = 0;
    for (const key in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, key)) {
        total += key.length + cookies[key].length; // Cada caractere ocupa 1 byte
      }
    }
    return (total / 1024).toFixed(2); // Retorna em KB
  };

  const clearLocalStorage = () => {
    localStorage.clear();
    window.location.reload();
  };

  const clearCookies = () => {
    const allCookies = Cookies.get();
    for (const key in allCookies) {
      if (!key.startsWith("@")) {
        Cookies.remove(key);
      }
    }

    window.location.reload();
  };
  return (
    <div className="settings-card bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
      <h2 className="card-title text-xl">Configurações da Plataforma</h2>
      <div className="flex-col">
        <div className="mt-4 flex-col space-y-2">
          <div className="flex cursor-not-allowed items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Ao receber Feedbacks de alunos:
            </h4>
            <Toggle
              className="pointer-events-none"
              ref={null}
              checked
              icons={false}
            />
          </div>
          <div className="flex cursor-not-allowed items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Quando alunos finalizarem treinos:
            </h4>
            <Toggle
              className="pointer-events-none"
              checked={false}
              icons={false}
            />
          </div>
          <div className="flex cursor-not-allowed items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Ao ativar um protocolo:
            </h4>
            <Toggle
              className="pointer-events-none"
              checked={false}
              icons={false}
            />
          </div>
          <div className="flex cursor-not-allowed items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Ao expirar um protocolo:
            </h4>
            <Toggle
              className="pointer-events-none"
              checked={false}
              icons={false}
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex-col">
        <h3 className="card-title text-xl">Configurações de Cache:</h3>
        <div className="mt-4 flex-col space-y-4">
          <div className="flex items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Limpar Cache <strong>({calculateLocalStorageSize()} kb):</strong>
            </h4>
            <button
              className="rounded-md px-2 py-1 text-sm font-bold text-red-500 hover:bg-red-200 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-900/30"
              onClick={() =>
                dialog.openDialog(
                  "Remover Cache",
                  "Esta ação irá remover dados em cache da aplicação.\nDados não salvos serão perdidos\nDeseja continuar?",
                  clearLocalStorage,
                )
              }
            >
              <p>Remover Dados</p>
            </button>
          </div>
          <div className="flex items-center justify-between">
            <h4 className="text-sm text-zinc-700 dark:text-zinc-200">
              Limpar Cookies: <strong>({calculateCookiesSize()} kb) - </strong>
            </h4>
            <button
              className="rounded-md px-2 py-1 text-sm font-bold text-red-500 hover:bg-red-200 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-900/30"
              onClick={() =>
                dialog.openDialog(
                  "Remover Cache",
                  "Esta ação irá remover dados em cache da aplicação.\nDados não salvos serão perdidos\nDeseja continuar?",
                  clearCookies,
                )
              }
            >
              <p>Remover Dados</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CacheSettings;
